// src/features/game/components/bottomsheets/StarPointConsumeSheet.tsx
import React from 'react';
import useBottomSheetStore from '@/shared/store/UseBottomSheetStore';
import FrameBox from '@/shared/components/ui/new/FrameBox';
import AppButton from '@/shared/components/ui/new/AppButton';

interface PersonInfoModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  personInfo?: BookPerson;
}

const PersonInfoModal: React.FC<PersonInfoModalProps> = ({ onConfirm, onCancel, personInfo }) => {
  const eraTextParts = personInfo?.eraText.split('(') || [];

  return (
    <>
      <div className="text-center text-[24px] font-bold mb-3 f-one-pop">
        {personInfo?.personName}
      </div>
      <FrameBox style={{ backgroundColor: 'white' }}>
        <div style={{ color: '#4B4B4B' }}>
          <div className="w-full text-center mb-4" style={{ fontSize: 14, color: '#8D8D8D' }}>
            {personInfo?.keywords}
          </div>
          <div className="w-full text-center mb-4" style={{ fontSize: 16, color: '#333333' }}>
            {eraTextParts[0]}
            {eraTextParts[1] && (
              <>
                <br />
                {`(${eraTextParts[1]}`}
              </>
            )}
          </div>
          <div className="flex">
            <div className="flex font-bold" style={{ width: 72, flexShrink: 0 }}>
              한줄소개 :
            </div>
            <div className="flex" style={{ fontSize: 13 }}>
              {personInfo?.oneLineIntro}
            </div>
          </div>
          <div className="flex">
            <div className="flex font-bold" style={{ width: 72, flexShrink: 0 }}>
              대표업적 :
            </div>
            <div className="flex" style={{ fontSize: 13 }}>
              {personInfo?.achievement1}
              {personInfo?.achievement1 && personInfo?.achievement2 && <br />}{' '}
              {personInfo?.achievement2}
            </div>
          </div>
        </div>
      </FrameBox>

      <div className="button-group" style={{ marginTop: 20 }}>
        <AppButton
          onConfirm={onCancel}
          backgroundColor="var(--color-btn)"
          boxShadowColor="var(--color-btn-border)"
          className="f-one-pop text-[20px]"
          message="확인"
        />
      </div>
    </>
  );
};

export default PersonInfoModal;
